import { useEffect, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import "./QrReader.css";

function QrReader({ onScan, showDialog }) {
	const [error, setError] = useState(null);

	useEffect(() => {
		const reader = new Html5Qrcode('reader', {});

		const config = {
			fps: 10, 
			qrbox: { width: 180, height: 180, aspectRatio: 1.0 },
		};

		const stopReader = (r) => {
			r.stop().then((ignore) => {
				// QR Code scanning is stopped.
				r.clear();
			}).catch((err) => {
				// Stop failed, handle it
			});
		}

		const onSuccess = (decodedText, decodedResult) => {
			if (onScan) {
				const err = onScan(decodedText);
				if (err === 0) {
					stopReader(reader);
					return;
				}
				setError("Neplatný QR kód.");
				return;
			}
			setError("Must implement callback");
		};

		if (showDialog) {
			reader.start({ facingMode: "environment" }, config, onSuccess);
		}

		return () => {
			if (reader.isScanning) {
				stopReader(reader);
			}
		};

	}, [showDialog, onScan]);

	return (
		<div>
			<h2 className="txt-center">Naskenuj QR&nbsp;kód</h2>
			<p className="txt-center">Naskenuj QR kód z plaketky v parku a otevři si novou sekci v aplikaci ze života stromů.</p>
			<p className="incorrect txt-center">{error}</p>
			<div id="reader"></div>
		</div>
	);
}

export default QrReader;
